/* Herb Terra footer, v3. Rebuilt 17-09-2026.
 * Accordion rows, open and closed at every screen width.
 * Height is measured from content so a longer list never clips.
 * Vanilla, defer loaded.
 */
(function () {
  'use strict';

  var root = document.querySelector('.htc-footer');
  if (!root) return;

  function body(row) {
    return row.querySelector('.htc-footer__row-body');
  }

  function setHeight(row, open) {
    var el = body(row);
    if (!el) return;
    el.style.maxHeight = open ? el.scrollHeight + 'px' : '0px';
  }

  function bindRows() {
    var rows = root.querySelectorAll('[data-htc-footer-col]');
    if (!rows.length) return;

    Array.prototype.forEach.call(rows, function (row) {
      var btn = row.querySelector('[data-htc-footer-toggle]');
      if (!btn) return;

      setHeight(row, row.getAttribute('data-open') === 'true');

      btn.addEventListener('click', function () {
        var open = row.getAttribute('data-open') === 'true';
        row.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        setHeight(row, !open);
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        Array.prototype.forEach.call(rows, function (row) {
          if (row.getAttribute('data-open') === 'true') setHeight(row, true);
        });
      }, 150);
    });
  }

  function focusNewsletterSuccess() {
    var msg = root.querySelector('[data-htc-footer-newsletter-success]');
    if (msg && typeof msg.focus === 'function') msg.focus();
  }

  function init() {
    bindRows();
    focusNewsletterSuccess();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
